import { cn } from '@/lib/utils'

import type { CSSProperties, HTMLAttributes } from 'react'

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode
  className?: string
  padding?: 'sm' | 'md' | 'lg' | 'none'
  border?: boolean
  shadow?: boolean
  style?: CSSProperties
}

export function Card({ children, className, padding = 'md', border = true, shadow = false, style, ...rest }: CardProps) {
  const paddings = { none: '', sm: 'p-4', md: 'p-6', lg: 'p-8' }
  return (
    <div
      className={cn(
        'bg-white rounded-xl',
        border && 'border border-border-gray',
        shadow && 'shadow-sm',
        paddings[padding],
        className
      )}
      style={style}
      {...rest}
    >
      {children}
    </div>
  )
}

export function CardHeader({ children, className }: { children: React.ReactNode; className?: string }) {
  return <div className={cn('mb-4', className)}>{children}</div>
}

export function CardTitle({ children, className }: { children: React.ReactNode; className?: string }) {
  return <h3 className={cn('text-base font-medium text-deep-ink', className)}>{children}</h3>
}
